import { css } from '@emotion/react'
import { mediaQuery, typo } from '@mathflat/common/style'

const S = {
  header: css`
    width: 100%;
    border-bottom: 1px solid var(--Colors-Gray-400);
    position: relative;

    .header-container {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 60px;
      margin: 0 auto;
      padding: 0 24px;

      ${mediaQuery.medium} {
        width: 100%;
      }
    }
    .header-container-left,
    .header-container-right {
      display: flex;
      align-items: center;
      flex: 1;
    }

    .header-container-left {
      gap: 8px;
    }

    .header-container-right {
      height: 100%;
    }
    .nav-link {
      display: flex;
      align-items: center;
      gap: 8px;
      height: 100%;
      /* 로고·과목전환 클러스터(8px)와 메뉴 사이는 24px 유지 */
      margin-left: 16px;
    }

    /* 위 24px 은 80px 고정폭인 과목전환 기준값이다. 학원 스위처는 학원명만큼 넓어져
       같은 여백이 과하게 비어 보이므로, 스위처가 놓인 경우에만 16px 로 줄인다. */
    .nav-link__academy-switch {
      margin-left: 8px;
    }

    .nav-link__daily-learning {
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .nav-link__daily-learning-beta {
      ${typo.caption01}
      display: inline-block;
      background: linear-gradient(90deg, var(--Colors-Sky-400) 0%, var(--Colors-Blue-600) 100%);
      color: transparent;
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      font-weight: 700;
    }

    &.schoolflat {
      ${mediaQuery.mediumLarge} {
        .nav-link {
          gap: 8px;
        }
      }
    }
  `,
}

export default S
